import { en } from './en';
import { az } from './az';
import { es } from './es';
import { fr } from './fr';
import { hy } from './hy';
import { id } from './id';
import { ka } from './ka';
import { nl } from './nl';
import { pt } from './pt';
import { zh } from './zh';

const globalLandcover = { en, az, es, fr, hy, id, ka, nl, pt, zh };
export default globalLandcover;
